import universal from 'react-universal-component';

export default universal(() => import('./Team'));



// WEBPACK FOOTER //
// ./src/app/views/Team/index.js